import intermind from '../../../index';
import { UpdateUserInfoParams, UserInfo } from '../../../types';

export class UserResource {
  async get(): Promise<UserInfo> {
    const { data } = await intermind.httpClient.get<UserInfo>('/users');
    return data;
  }

  async update(updateParams: UpdateUserInfoParams): Promise<UserInfo> {
    const { data } = await intermind.httpClient.patch<UserInfo>('/users', updateParams);
    return data;
  }
  async delete(): Promise<void> {
    await intermind.httpClient.delete('/users');
  }
}
